import React from "react";
import classes from "./MessagingDetailsCard.module.css";

const MessagingDetailsCard = (props) => {
  return (
    <div className={classes.cardContainer}>
      <div className={classes.cardContent}>
        <div className={classes.cardInfo}>
          <span className={classes.siteName}>{props?.outerTitle}</span>
        </div>
      </div>
    </div>
  );
};

export default MessagingDetailsCard;
